// Pure helper functions for the Smartsheet feature.
// No React dependencies — safe to unit-test without a DOM.

/**
 * Format a date string or Date object for display in the sheet.
 * Returns "—" for falsy input.
 * @param {string|Date|null|undefined} d
 * @returns {string}
 */
export function fmtDate(d) {
  if (!d) return "—";
  return new Date(d).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "2-digit" });
}

/**
 * Convert a date string or Date object to YYYY-MM-DD for <input type="date">.
 * Returns "" for falsy input.
 * @param {string|Date|null|undefined} d
 * @returns {string}
 */
export function toDateInput(d) {
  if (!d) return "";
  return new Date(d).toISOString().split("T")[0];
}

/**
 * Resolve the accent colour for the phase progress bar based on completion %.
 * @param {number|null} pct  0-100, or null when there are no tasks
 * @returns {string}  CSS colour
 */
export function phaseBarColor(pct) {
  if (pct === null) return "#e2e8f0";
  if (pct >= 70) return "#22c55e";
  if (pct >= 30) return "#f59e0b";
  return "#ef4444";
}
